import { render, staticRenderFns } from "./IconAdd.vue?vue&type=template&id=c253200c&scoped=true&lang=pug"
import script from "./IconAdd.vue?vue&type=script&lang=js"
export * from "./IconAdd.vue?vue&type=script&lang=js"
import style0 from "./IconAdd.vue?vue&type=style&index=0&id=c253200c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c253200c",
  null
  
)

export default component.exports